export default __webpack_public_path__ + "static/media/08.a8fed3ba.jpg";